import { Box, Modal } from "@mui/material";
import DragDropFile from "../../../components/drag-drop-file/DragDropFile";
import { useState } from "react";
import { useMutation } from "react-query";
import { createEntreatyApi } from "../../../api/create-entreaty-api/create-entreaty-api";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const CreateEntreatyModal = ({ openModal, handleClose, callId }) => {
  const { mutateAsync } = useMutation(createEntreatyApi);

  const handleFileChange = (file) => {
    mutateAsync({ callId: callId, file: file });
    handleClose();
  };

  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <DragDropFile handleFileChange={handleFileChange} />
      </Box>
    </Modal>
  );
};

export default CreateEntreatyModal;
